const SEO = [
	{
	  page: "home",
	  description:
		"Welcome to my personal website! I'm a passionate developer with a love for all things tech. Explore my portfolio and discover my journey through the digital world.",
	  keywords: ["Pratyush sinha", "developer", "portfolio"],
	},
  
	{
	  page: "about",
	  description:
		"Get to know me better! I'm an enthusiastic coder who enjoys solving complex problems and building innovative solutions using cutting-edge technologies.",
	  keywords: ["Pratyush sinha", "coder", "innovative solutions"],
	},
  
	{
	  page: "articles",
	  description:
		"Dive into a world of knowledge and insights. Explore my articles on a wide range of topics, from coding to leadership, and broaden your horizons.",
	  keywords: ["Pratyush sinha", "knowledge", "coding"],
	},
  
	{
	  page: "projects",
	  description:
		"Discover the fruits of my labor! I've worked on a diverse set of projects, from open-source contributions to personal creations. Join me in the journey of innovation.",
	  keywords: ["Pratyush sinha", "projects", "innovation"],
	},
  
	{
	  page: "contact",
	  description:
		"Let's connect and create something amazing together. If you have an exciting project or idea, don't hesitate to reach out. I'm always up for a new adventure!",
	  keywords: ["Pratyush sinha", "collaboration", "new adventure"],
	},
  ];
  
  export default SEO;
  